import axios from 'axios';
import {Org, Project, User} from 'rendition-core/types/Rendition';

interface OrgsWithProjects extends Omit<Org, 'projects'> {
    projects: Project[];
}

export async function getOrgs({userId}: {userId: string}) {
    const res = await axios.get<{orgs: Array<OrgsWithProjects>}>('/user/orgs', {
        params: {userId},
    });

    return res.data.orgs;
}

export async function getGithubUser({userId}: {userId: string}) {
    const res = await axios.get<{githubUser: Object | null}>('/user/github', {
        params: {userId},
    });

    return res.data.githubUser;
}

export async function getUser({userId}: {userId: string}) {
    const res = await axios.get<{availableCredits: number}>(`/user/${userId}`);

    return res.data;
}

export async function createUser(user: {id: string; googleUser: User['googleUser']}) {
    const res = await axios.post<{user: User}>(`/user`, user);

    return res.data;
}
